import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  check: {
    defaultMessage: 'Check',
    description: 'Payment method Option Check'
  },
  creditCard: {
    defaultMessage: 'Virtual Card',
    description: 'Payment method Option Virtual Card'
  }
});
